import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'letter-m-small', 'LetterMSmall', [["path",{"d":"M9 16v-8l3 5l3 -5v8"}]]);